module.exports = __webpack_public_path__ + "static/media/month_07.9903adec.png";